import React from 'react';
import { Dashboard } from '@components/common';
import { HeadContent, Pagination } from '@fourthwall/components';
import { GiveawaysData } from './components/GiveawaysData/GiveawaysData';
import { useGiveaways } from './hooks/useGiveaways';
export const GiveawaysList = () => {
    const { giveaways: { table, list, pagination }, } = useGiveaways();
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Twitch gifts" }),
        React.createElement(Dashboard.Section.Item, null,
            React.createElement(GiveawaysData, { list: list, table: table })),
        pagination && (React.createElement(Dashboard.Section.Item, null,
            React.createElement(Pagination, { ...pagination })))));
};
